@switch (displayAs) {
@default {
<div class="flex flex-middle">
    <!-- select -->
    <dropdown class="m-l-1"
              (valueChange)="sortBy($event)"
              [options]="options"
              alignOptions="left"
              [hideIcon]="true">
        <ng-template #titleTpl>
            <div class="h4 col-1">
                <button class="button-3 button-size-1">{{'Sort' | translate}}</button>
            </div>
        </ng-template>
        <ng-template #optionTpl
                     let-option>
            <div class="p1 b-b b-col-42 p-t-2 p-b-2 p-l-3 p-r-3 no-wrap">{{option.label | translate}}</div>
        </ng-template>
    </dropdown>
</div>
}
@case ('buttons') {
<div class="flex flex-justify-center">
    <div class="p-l-2 p-l-0-s p-r-2 p-r-0-s p-b flex flex-wrap flex-justify-between w-8 w-12-s">
        @for (option of options; track $index) {
        <button class="b-a b-col-42 col-11 p1 p-a p-t-3 p-b-3 m-b"
                (click)="sortBy(option)"
                [class.bg-col-42]="isSelected(option)">{{option.label | translate}}
        </button>
        }
    </div>
</div>
}
}